export class SubscriberAddressModel {
    id?: number
    street: string = ''
    number?: string = ''
    neighborhood: string = ''
    complement: string = ''
    city: string = ''
    state: string = ''
    postalCode: string = ''
    email: string = ''
    phone: string = ''
    cellPhone: string = ''
    cityIbgeCode: string = ''
    
    constructor(s?:Partial<SubscriberAddressModel>) {
        Object.assign(this, s)
    }

    getEmailList():string[] {
        if (!this.email) {
            return []
        }

        return this.email.split(',')
    }
}
